import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import Heading from 'components/heading';
import Button from 'components/button';
import ContentWrapper from 'components/content-wrapper';
import cn from 'classnames';

const themes = { dark: 'dark', light: 'light' };

const HousingProjectDiagonalImagePair = ({
  landscapeImage,
  portraitImage,
  title,
  text,
  link,
  theme
}) => {
  return (
    <div
      className={cn('housing-project-diagonal-image-pair', {
        [`housing-project-diagonal-image-pair--${theme}`]: theme
      })}
    >
      <ContentWrapper className="housing-project-diagonal-image-pair__wrapper">
        <div className="housing-project-diagonal-image-pair__image housing-project-diagonal-image-pair__image-landscape">
          <Image {...landscapeImage} />
        </div>
        <div className="housing-project-diagonal-image-pair__content">
          <Heading
            level={2}
            className="housing-project-diagonal-image-pair__heading"
          >
            {title}
          </Heading>
          <p className="housing-project-diagonal-image-pair__text">{text}</p>
          {link && (
            <div className="housing-project-diagonal-image-pair__link">
              <Button
                housingProjectBaseTheme={
                  theme === themes.dark ? 'dark' : 'light'
                }
                housingProjectButtonTheme="primary"
                alignment={'center'}
                {...link}
              />
            </div>
          )}
        </div>
        <div className="housing-project-diagonal-image-pair__image housing-project-diagonal-image-pair__image-portrait">
          <Image {...portraitImage} />
        </div>
      </ContentWrapper>
    </div>
  );
};

HousingProjectDiagonalImagePair.propTypes = {
  landscapeImage: PropTypes.exact(Image.propTypes),
  portraitImage: PropTypes.exact(Image.propTypes),
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  link: PropTypes.exact(Button.propTypes),
  theme: PropTypes.oneOf(Object.values(themes))
};

export default HousingProjectDiagonalImagePair;
